import classNames from 'classnames';
import * as BrandDefinition from 'modules/BrandDefinition';
import React from 'react';
import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import { DefaultCustomStyle } from 'const';
import { CharacterStyleMap } from 'models';
import * as Models from 'models';
import { getCharacterStyle } from 'utils/brandStyles';
import styles from './styles.module.scss';

type Props = {
  activeFont: BrandDefinition.BrandFontRef | undefined;
  fonts: Models.BrandFontsList;
  font: Models.BrandFontMap;
  toggleFontFamily(font: Models.BrandFontMap, charStyle: Models.CharacterStyleMap): void;
  dataTestId?: string;
};

const Font: React.FunctionComponent<Props> = (props) => {
  const {
    activeFont,
    font,
    fonts,
    toggleFontFamily,
    dataTestId = 'font',
  } = props;

  const characterStyles = font.get('characterStyles');
  const fontName = font.get('name');
  const transformedFontFamily = BrandDefinition.getBrandFontValueFontFamily(
    fonts,
    { fontName, characterStyleName: undefined },
    true,
    DefaultCustomStyle.FONT_FAMILY,
  );
  const hasCharacterStyles = characterStyles && characterStyles.size !== 0;
  const charStyleForFontClick = getCharacterStyle(characterStyles);
  const isActiveFont = activeFont?.fontName === fontName;

  const handleClick = (charStyle: CharacterStyleMap): () => void => () => {
    toggleFontFamily(font, charStyle);
  };

  return (
    <div className={styles.Font} data-testid={dataTestId}>
      <div
        className={classNames(styles.fontNameWrapper, { [styles.active]: isActiveFont })}
        onClick={handleClick(charStyleForFontClick)}
        style={{ fontFamily: transformedFontFamily }}
        data-testid={`${dataTestId}-wrapper`}
      >
        <div data-testid={`${dataTestId}-name`}>{fontName}</div>
        {hasCharacterStyles &&
          <div className={styles.fontListChevron}>
            <Icon type={IconType.CHEVRON_DOWN} size="badge" color={isActiveFont ? 'primary' : 'secondary'} data-testid={dataTestId}/>
          </div>
        }
      </div>
      {hasCharacterStyles &&
        <div className={styles.charStylesList} data-testid={`${dataTestId}-charStylesList`}>
          {
            characterStyles.map((charStyle: Models.CharacterStyleMap, index) => {
              const charStyleName = charStyle.get('name');
              const updatedFontFamily = BrandDefinition.getBrandFontValueFontFamily(
                fonts,
                { fontName, characterStyleName: charStyleName },
                false,
                DefaultCustomStyle.FONT_FAMILY,
              );
              const fontStyle = charStyle.get('fontStyle');
              const fontWeight = charStyle.get('fontWeight');
              const isActive = isActiveFont && charStyleName === activeFont?.characterStyleName;

              return (
                <div
                  className={classNames(styles.charStyle, { [styles.active]: isActive })}
                  key={charStyleName}
                  style={{ fontFamily: updatedFontFamily, fontStyle, fontWeight }}
                  onClick={handleClick(charStyle)}
                  data-testid={`${dataTestId}-charStylesList-charStyle${index}`}
                >
                  {charStyleName}
                </div>
              );
            })
          }
        </div>
      }
    </div>
  );
};

export default Font;
